import { render, staticRenderFns } from "./BuyNowPayLaterPanel.vue?vue&type=template&id=0a05fc4c&scoped=true"
import script from "./BuyNowPayLaterPanel.vue?vue&type=script&lang=js"
export * from "./BuyNowPayLaterPanel.vue?vue&type=script&lang=js"
import style0 from "./BuyNowPayLaterPanel.vue?vue&type=style&index=0&id=0a05fc4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a05fc4c",
  null
  
)

export default component.exports